// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-page.company-info-page .company-photo-section .salon-photo-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.business-page.company-info-page .company-photo-section .salon-photo-heading h2 {
  margin: 0;
}
.business-page.company-info-page .company-photo-section .salon-photo-heading p {
  margin: 4px 0 0;
  font-size: 11px;
  line-height: 1.4;
  color: #8590a3;
}
.business-page.company-info-page .company-photo-section .salon-photo-heading-icon, .business-page.company-info-page .company-photo-section .salon-photo-upload-heading > span {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  color: #de5266;
  background: #fff0f2;
  border-radius: 11px;
}
.business-page.company-info-page .company-photo-section .salon-photo-heading-icon svg, .business-page.company-info-page .company-photo-section .salon-photo-upload-heading > span svg {
  width: 21px;
  height: 21px;
}
.business-page.company-info-page .company-photo-section .salon-photo-gallery {
  padding: 0 16px 16px;
}
.business-page.company-info-page .company-photo-section .salon-photo-sources {
  display: flex;
  gap: 5px;
  overflow-x: auto;
  padding: 2px 1px 12px;
  scrollbar-width: none;
}
.business-page.company-info-page .company-photo-section .salon-photo-sources::-webkit-scrollbar {
  display: none;
}
.business-page.company-info-page .company-photo-section .salon-photo-sources button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  flex-shrink: 0;
  min-height: 38px;
  padding: 7px 9px;
  border-radius: 10px;
  border: 1px solid #e6eaf1;
  background: #fff;
  color: #68758b;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
}
.business-page.company-info-page .company-photo-section .salon-photo-sources button span {
  min-width: 16px;
  padding: 1px 3px;
  border-radius: 5px;
  background: #f2f4f8;
  color: #8791a2;
  font-variant-numeric: tabular-nums;
}
.business-page.company-info-page .company-photo-section .salon-photo-sources button[aria-pressed=true] {
  background: #fff1f3;
  border-color: #f1bec7;
  color: #c73752;
}
.business-page.company-info-page .company-photo-section .salon-photo-sources button[aria-pressed=true] span {
  background: #ffe1e7;
  color: #c73752;
}
.business-page.company-info-page .company-photo-section .salon-photo-grid {
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px 9px;
}
.business-page.company-info-page .company-photo-section .salon-photo-grid figure {
  margin: 0;
  min-width: 0;
}
.business-page.company-info-page .company-photo-section .salon-photo-grid figcaption {
  padding: 6px 1px 0;
}
.business-page.company-info-page .company-photo-section .salon-photo-grid figcaption strong {
  display: block;
  font-size: 11px;
  font-weight: 550;
  color: #45536a;
}
.business-page.company-info-page .company-photo-section .salon-photo-grid figcaption > span {
  display: block;
  color: #8a95a6;
  font-size: 10px;
  line-height: 1.4;
  margin-top: 3px;
}
.business-page.company-info-page .company-photo-section .salon-photo-thumb {
  display: block;
  position: relative;
  padding: 0;
  width: 100%;
  aspect-ratio: 1.12;
  min-height: 88px;
  border: 0;
  border-radius: 11px;
  overflow: hidden;
  background: #eef1f5;
  cursor: pointer;
}
.business-page.company-info-page .company-photo-section .salon-photo-thumb img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
  transition: transform 0.18s;
}
.business-page.company-info-page .company-photo-section .salon-photo-thumb > span:not(.salon-photo-unavailable) {
  position: absolute;
  bottom: 6px;
  left: 6px;
  max-width: calc(100% - 12px);
  padding: 3px 5px;
  border-radius: 5px;
  color: #fff;
  background: rgba(36, 48, 68, 0.7215686275);
  font-size: 9px;
  line-height: 1.2;
}
.business-page.company-info-page .company-photo-section .salon-photo-thumb:hover img {
  transform: scale(1.025);
}
.business-page.company-info-page .company-photo-section .salon-photo-empty {
  display: grid;
  justify-items: center;
  text-align: center;
  padding: 24px 14px 18px;
  border: 1px solid #edf0f5;
  background: #fafbfc;
  border-radius: 13px;
}
.business-page.company-info-page .company-photo-section .salon-photo-empty > svg {
  width: 32px;
  height: 32px;
  color: #b7c0ce;
  margin-bottom: 11px;
}
.business-page.company-info-page .company-photo-section .salon-photo-empty strong {
  color: #68758b;
  font-size: 13px;
  font-weight: 550;
}
.business-page.company-info-page .company-photo-section .salon-photo-empty p {
  margin: 7px 0 0;
  color: #9099aa;
  font-size: 12px;
  line-height: 1.5;
  max-width: 260px;
}
.business-page.company-info-page .company-photo-section .salon-photo-hint {
  font-size: 11px;
  line-height: 1.6;
  margin: 12px 0 0;
  color: #8792a5;
}
.business-page.company-info-page .company-photo-section .salon-photo-more {
  display: block;
  margin: 12px auto 0;
  padding: 8px 14px;
  min-height: 42px;
  color: #68758b;
  font-size: 12px;
  background: #f5f7fa;
  border: 0;
  border-radius: 9px;
  cursor: pointer;
}
.business-page.company-info-page .company-photo-section .salon-photo-upload {
  position: relative;
  padding: 18px 16px 16px;
  border-top: 1px solid #edf0f5;
  display: grid;
  gap: 14px;
}
.business-page.company-info-page .company-photo-section .salon-photo-upload .salon-photo-hint {
  margin: 0;
}
.business-page.company-info-page .company-photo-section .salon-photo-upload-heading {
  display: flex;
  align-items: center;
  gap: 10px;
}
.business-page.company-info-page .company-photo-section .salon-photo-upload-heading h3 {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
}
.business-page.company-info-page .company-photo-section .salon-photo-upload-heading p {
  margin: 3px 0 0;
  font-size: 11px;
  color: #8792a5;
}
.business-page.company-info-page .company-photo-section .salon-photo-upload-heading > span {
  width: 31px;
  height: 31px;
  border-radius: 9px;
}
.business-page.company-info-page .company-photo-section .salon-photo-pick {
  display: grid;
  justify-items: center;
  text-align: center;
  padding: 19px 12px;
  border: 1px dashed #ebbdc6;
  border-radius: 14px;
  background: linear-gradient(140deg, #fff7f8, #fcfdff);
}
.business-page.company-info-page .company-photo-section .salon-photo-pick > strong {
  font-size: 13px;
  color: #566178;
  font-weight: 550;
}
.business-page.company-info-page .company-photo-section .salon-photo-pick > p {
  color: #8a93a3;
  font-size: 12px;
  line-height: 1.55;
  margin: 7px 0 13px;
}
.business-page.company-info-page .company-photo-section .salon-photo-pick > small {
  color: #99a1af;
  font-size: 10px;
  margin-top: 10px;
  line-height: 1.5;
}
.business-page.company-info-page .company-photo-section .salon-photo-pick-icon {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 13px;
  margin-bottom: 12px;
  background: #fff;
  color: #e88495;
  box-shadow: 0 3px 10px rgba(212, 84, 112, 0.062745098);
}
.business-page.company-info-page .company-photo-section .salon-photo-pick-icon svg {
  width: 25px;
  height: 25px;
}
.business-page.company-info-page .company-photo-section .salon-photo-select {
  display: inline-flex;
  gap: 7px;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 9px 17px;
  border: 1px solid #edc8d0;
  border-radius: 10px;
  background: #fff;
  color: #cd4d66;
  font-size: 13px;
  font-weight: 550;
  cursor: pointer;
}
.business-page.company-info-page .company-photo-section .salon-photo-select svg {
  width: 18px;
  height: 18px;
}
.business-page.company-info-page .company-photo-section .salon-photo-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  padding: 0;
  border: 0;
  opacity: 0;
}
.business-page.company-info-page .company-photo-section .salon-photo-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.business-page.company-info-page .company-photo-section .salon-photo-options label {
  display: grid;
  gap: 6px;
  font-size: 11px;
  color: #7a8599;
  min-width: 0;
}
.business-page.company-info-page .company-photo-section .salon-photo-options select {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  min-height: 44px;
  padding: 9px;
  font-size: 16px;
  background: #fff;
  border: 1px solid #dfe5ee;
  border-radius: 10px;
  color: #47546c;
}
.business-page.company-info-page .company-photo-section .salon-photo-selected {
  display: grid;
  gap: 8px;
}
.business-page.company-info-page .company-photo-section .salon-photo-selected > div {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border: 1px solid #e8ecf3;
  border-radius: 10px;
  min-width: 0;
}
.business-page.company-info-page .company-photo-section .salon-photo-selected img {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}
.business-page.company-info-page .company-photo-section .salon-photo-selected span {
  display: grid;
  min-width: 0;
  gap: 4px;
  flex: 1 1;
}
.business-page.company-info-page .company-photo-section .salon-photo-selected span strong {
  font-size: 11px;
  color: #59657b;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.business-page.company-info-page .company-photo-section .salon-photo-selected span small {
  color: #9aa3b2;
  font-size: 10px;
}
.business-page.company-info-page .company-photo-section .salon-photo-selected button {
  display: grid;
  place-items: center;
  border: 0;
  background: #f5f7fa;
  color: #939cac;
  width: 36px;
  min-height: 44px;
  border-radius: 8px;
}
.business-page.company-info-page .company-photo-section .salon-photo-selected button svg {
  width: 16px;
  height: 16px;
}
.business-page.company-info-page .company-photo-section .salon-photo-submit {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  border: 0;
  border-radius: 11px;
  background: #e9748c;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.business-page.company-info-page .company-photo-section .salon-photo-submit:disabled {
  opacity: 1;
  background: #f7d8df;
  color: #fff;
  cursor: default;
}
.business-page.company-info-page .company-photo-section .salon-photo-progress {
  display: grid;
  gap: 7px;
  font-size: 12px;
  color: #78849a;
}
.business-page.company-info-page .company-photo-section .salon-photo-progress progress {
  width: 100%;
  height: 5px;
  accent-color: #df718a;
}
.business-page.company-info-page .company-photo-section .salon-photo-error, .business-page.company-info-page .company-photo-section .salon-photo-success {
  margin: 0;
  padding: 10px 12px;
  border-radius: 9px;
  line-height: 1.5;
  font-size: 12px;
  overflow-wrap: anywhere;
}
.business-page.company-info-page .company-photo-section .salon-photo-error {
  color: #b34b54;
  background: #fff2f2;
}
.business-page.company-info-page .company-photo-section .salon-photo-success {
  color: #388467;
  background: #f0faf5;
}
@media (max-width: 390px) {
  .business-page.company-info-page .company-photo-section .salon-photo-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .business-page.company-info-page .company-photo-section .company-info-card-heading {
    gap: 5px;
  }
  .business-page.company-info-page .company-photo-section .salon-photo-heading {
    gap: 7px;
  }
  .business-page.company-info-page .company-photo-section .salon-photo-heading-icon {
    width: 30px;
    height: 30px;
  }
  .business-page.company-info-page .company-photo-section .salon-photo-sources button {
    padding: 7px 8px;
    font-size: 10px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .business-page.company-info-page .company-photo-section .salon-photo-thumb img {
    transition: none;
  }
}

.salon-photo-unavailable {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  color: #9aa6b6;
  font-size: 10px;
  padding: 8px;
  box-sizing: border-box;
}
.salon-photo-unavailable svg {
  width: 24px;
  height: 24px;
}

.salon-photo-viewer {
  position: fixed;
  inset: 0;
  z-index: 10020;
  padding: max(16px, env(safe-area-inset-top)) 14px max(16px, env(safe-area-inset-bottom));
  box-sizing: border-box;
  display: grid;
  place-items: center;
  background: rgba(24, 35, 56, 0.8745098039);
  overscroll-behavior: contain;
}
.salon-photo-viewer > div {
  width: min(880px, 100%);
  min-width: 0;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  outline: none;
  box-shadow: 0 20px 80px rgba(0, 0, 0, 0.2666666667);
}
.salon-photo-viewer header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 15px;
  color: #3e4b64;
}
.salon-photo-viewer header > div {
  min-width: 0;
  display: grid;
  gap: 5px;
}
.salon-photo-viewer header strong {
  font-size: 14px;
}
.salon-photo-viewer header span {
  font-size: 12px;
  color: #8c97a7;
}
.salon-photo-viewer button {
  border: 0;
  background: #f2f5f9;
  color: #5d6b83;
  border-radius: 9px;
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  cursor: pointer;
}
.salon-photo-viewer button:disabled {
  opacity: 0.35;
}
.salon-photo-viewer button svg {
  width: 20px;
  height: 20px;
}
.salon-photo-viewer button:focus-visible {
  outline: 3px solid #dc6c85;
}
.salon-photo-viewer footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 10px;
  color: #7b879a;
  font-size: 12px;
}
.salon-photo-viewer .salon-photo-next {
  display: flex;
  transform: rotate(180deg);
}

.salon-photo-viewer-image {
  background: #f3f5f8;
  width: 100%;
  height: min(68vh, 680px);
  height: min(68dvh, 680px);
  display: grid;
  place-items: center;
}
.salon-photo-viewer-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/pages/CompanyInfoPage/CompanyMapsPhotos.scss"],"names":[],"mappings":"AACE;EAAuB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,YAAA;AAIxE;AAJsF;EAAK,SAAA;AAO3F;AAPwG;EAAI,eAAA;EAAiB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AAahK;AAZE;EAAgE,aAAA;EAAe,mBAAA;EAAqB,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,mBAAA;EAAqB,mBAAA;AAsBtL;AAtB2M;EAAM,WAAA;EAAa,YAAA;AA0B9N;AAzBE;EAAuB,oBAAA;AA4BzB;AA3BE;EAAuB,aAAA;EAAe,QAAA;EAAU,gBAAA;EAAkB,qBAAA;EAAuB,qBAAA;AAkC3F;AAlCkH;EAAuB,aAAA;AAqCzI;AArC0J;EAAS,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,cAAA;EAAgB,gBAAA;EAAkB,gBAAA;EAAkB,mBAAA;EAAqB,yBAAA;EAA2B,gBAAA;EAAkB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AAqD1Z;AArD2a;EAAO,eAAA;EAAiB,gBAAA;EAAkB,kBAAA;EAAoB,mBAAA;EAAqB,cAAA;EAAgB,kCAAA;AA6D9gB;AA7DojB;EAAuB,mBAAA;EAAqB,qBAAA;EAAuB,cAAA;AAkEvnB;AAlEuoB;EAAO,mBAAA;EAAqB,cAAA;AAsEnqB;AArEE;EAAoB,UAAA;EAAY,aAAA;EAAe,gDAAA;EAAkD,aAAA;AA2EnG;AA3EkH;EAAS,SAAA;EAAW,YAAA;AA+EtI;AA/EsJ;EAAa,kBAAA;AAkFnK;AAlFuL;EAAS,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AAwFnP;AAxFqQ;EAAS,cAAA;EAAgB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AA+FjV;AA9FE;EAAqB,cAAA;EAAgB,kBAAA;EAAoB,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,gBAAA;EAAkB,SAAA;EAAW,mBAAA;EAAqB,gBAAA;EAAkB,mBAAA;EAAqB,eAAA;AA2GjM;AA3GkN;EAAM,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,iBAAA;EAAmB,gBAAA;EAAkB,2BAAA;AAmHxS;AAnHsU;EAAuC,kBAAA;EAAoB,WAAA;EAAa,SAAA;EAAW,4BAAA;EAA8B,gBAAA;EAAkB,kBAAA;EAAoB,WAAA;EAAa,0CAAA;EAAuB,cAAA;EAAgB,gBAAA;AA+HjhB;AA/HqiB;EAAc,uBAAA;AAkInjB;AAjIE;EAAqB,aAAA;EAAe,qBAAA;EAAuB,kBAAA;EAAoB,uBAAA;EAAyB,yBAAA;EAA2B,mBAAA;EAAqB,mBAAA;AA0I1J;AA1I+K;EAAQ,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,mBAAA;AAgJlO;AAhJyP;EAAS,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAqJnS;AArJuT;EAAI,eAAA;EAAiB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;AA4J/X;AA3JE;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;EAAkB,cAAA;AAiK3E;AAhKE;EAAoB,cAAA;EAAgB,mBAAA;EAAqB,iBAAA;EAAmB,gBAAA;EAAkB,cAAA;EAAgB,eAAA;EAAiB,mBAAA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,eAAA;AA4KrL;AA3KE;EAAsB,kBAAA;EAAoB,uBAAA;EAAyB,6BAAA;EAA+B,aAAA;EAAe,SAAA;AAkLnH;AAlL8H;EAAoB,SAAA;AAqLlJ;AApLE;EAA8B,aAAA;EAAe,mBAAA;EAAqB,SAAA;AAyLpE;AAzL+E;EAAK,SAAA;EAAW,eAAA;EAAiB,gBAAA;AA8LhH;AA9LoI;EAAI,eAAA;EAAiB,eAAA;EAAiB,cAAA;AAmM1K;AAnM4L;EAAS,WAAA;EAAa,YAAA;EAAc,kBAAA;AAwMhO;AAvME;EAAoB,aAAA;EAAe,qBAAA;EAAuB,kBAAA;EAAoB,kBAAA;EAAoB,0BAAA;EAA4B,mBAAA;EAAqB,qDAAA;AAgNrJ;AAhN4M;EAAW,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AAqNxP;AArN4Q;EAAM,cAAA;EAAgB,eAAA;EAAiB,iBAAA;EAAmB,kBAAA;AA2NtU;AA3N4V;EAAU,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;AAiOzZ;AAhOE;EAAyB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,gBAAA;EAAkB,cAAA;EAAgB,sDAAA;AA2OtK;AA3OwM;EAAM,WAAA;EAAa,YAAA;AA+O3N;AA9OE;EAAsB,oBAAA;EAAsB,QAAA;EAAU,mBAAA;EAAqB,uBAAA;EAAyB,gBAAA;EAAkB,iBAAA;EAAmB,yBAAA;EAA2B,mBAAA;EAAqB,gBAAA;EAAkB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AA6PhQ;AA7PiR;EAAM,WAAA;EAAa,YAAA;AAiQpS;AAhQE;EAA0B,kBAAA;EAAoB,UAAA;EAAY,WAAA;EAAa,gBAAA;EAAkB,qBAAA;EAAuB,UAAA;EAAY,SAAA;EAAW,UAAA;AA0QzI;AAzQE;EAAuB,aAAA;EAAe,gDAAA;EAAkD,SAAA;AA8Q1F;AA9QqG;EAAQ,aAAA;EAAe,QAAA;EAAU,eAAA;EAAiB,cAAA;EAAgB,YAAA;AAqRvK;AArRuL;EAAS,WAAA;EAAa,YAAA;EAAc,sBAAA;EAAwB,gBAAA;EAAkB,YAAA;EAAc,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,mBAAA;EAAqB,cAAA;AAiStW;AAhSE;EAAwB,aAAA;EAAe,QAAA;AAoSzC;AApSmD;EAAQ,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,YAAA;EAAc,yBAAA;EAA2B,mBAAA;EAAqB,YAAA;AA6SxK;AA7SwL;EAAM,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,iBAAA;EAAmB,cAAA;AAoThQ;AApTkR;EAAO,aAAA;EAAe,YAAA;EAAc,QAAA;EAAU,SAAA;AA0ThU;AA1TyU;EAAS,eAAA;EAAiB,cAAA;EAAgB,gBAAA;EAAkB,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AAkUhb;AAlUuc;EAAQ,cAAA;EAAgB,eAAA;AAsU/d;AAtUof;EAAS,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,mBAAA;EAAqB,cAAA;EAAgB,WAAA;EAAa,gBAAA;EAAkB,kBAAA;AAgVhnB;AAhVooB;EAAM,WAAA;EAAa,YAAA;AAoVvpB;AAnVE;EAAsB,WAAA;EAAa,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,gBAAA;EAAkB,SAAA;EAAW,mBAAA;EAAqB,mBAAA;EAAqB,WAAA;EAAa,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AAiWhO;AAjWiP;EAAa,UAAA;EAAY,mBAAA;EAAqB,WAAA;EAAa,eAAA;AAuW5S;AAtWE;EAAwB,aAAA;EAAe,QAAA;EAAU,eAAA;EAAiB,cAAA;AA4WpE;AA5WoF;EAAW,WAAA;EAAa,WAAA;EAAa,qBAAA;AAiXzH;AAhXE;EAA2C,SAAA;EAAW,kBAAA;EAAoB,kBAAA;EAAoB,gBAAA;EAAkB,eAAA;EAAiB,uBAAA;AAwXnI;AAvXE;EAAqB,cAAA;EAAgB,mBAAA;AA2XvC;AA1XE;EAAuB,cAAA;EAAgB,mBAAA;AA8XzC;AA7XE;EAA2B;IAAoB,gDAAA;EAiY/C;EAjYmG;IAA6B,QAAA;EAoYhI;EApY4I;IAAuB,QAAA;EAuYnK;EAvY+K;IAA4B,WAAA;IAAa,YAAA;EA2YxN;EA3YwO;IAA8B,gBAAA;IAAkB,eAAA;EA+YxR;AACF;AA/YE;EAAyC;IAAyB,gBAAA;EAmZlE;AACF;;AAlZA;EAA2B,WAAA;EAAa,YAAA;EAAc,aAAA;EAAe,sBAAA;EAAwB,uBAAA;EAAyB,mBAAA;EAAqB,QAAA;EAAU,cAAA;EAAgB,eAAA;EAAiB,YAAA;EAAc,sBAAA;AAgapM;AAha4N;EAAM,WAAA;EAAa,YAAA;AAoa/O;;AAnaA;EAAsB,eAAA;EAAiB,QAAA;EAAU,cAAA;EAAgB,wFAAA;EAA0F,sBAAA;EAAwB,aAAA;EAAe,mBAAA;EAAqB,0CAAA;EAAuB,4BAAA;AA+a9O;AA/a4Q;EAAQ,uBAAA;EAAyB,YAAA;EAAc,mBAAA;EAAqB,gBAAA;EAAkB,gBAAA;EAAkB,aAAA;EAAe,mDAAA;AAwbnY;AAxboa;EAAS,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,kBAAA;EAAoB,cAAA;AAgchhB;AAhcgiB;EAAQ,YAAA;EAAc,aAAA;EAAe,QAAA;AAqcrkB;AArcilB;EAAS,eAAA;AAwc1lB;AAxc6mB;EAAO,eAAA;EAAiB,cAAA;AA4croB;AA5cypB;EAAS,SAAA;EAAW,mBAAA;EAAqB,cAAA;EAAgB,kBAAA;EAAoB,WAAA;EAAa,YAAA;EAAc,aAAA;EAAe,mBAAA;EAAqB,cAAA;EAAgB,eAAA;AAwdrzB;AAxds0B;EAAa,aAAA;AA2dn1B;AA3dm2B;EAAM,WAAA;EAAa,YAAA;AA+dt3B;AA/ds4B;EAAkB,0BAAA;AAkex5B;AAlew7B;EAAS,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,SAAA;EAAW,aAAA;EAAe,cAAA;EAAgB,eAAA;AA2exiC;AA3e2jC;EAAoB,aAAA;EAAe,yBAAA;AA+e9lC;;AA9eA;EAA4B,mBAAA;EAAqB,WAAA;EAAa,wBAAA;EAA0B,yBAAA;EAA2B,aAAA;EAAe,mBAAA;AAuflI;AAvfuJ;EAAM,WAAA;EAAa,YAAA;EAAc,mBAAA;AA4fxL","sourcesContent":[".business-page.company-info-page .company-photo-section {\n  .salon-photo-heading { display: flex; align-items: center; gap: 10px; min-width: 0; h2 { margin: 0; } p { margin: 4px 0 0; font-size: 11px; line-height: 1.4; color: #8590a3; } }\n  .salon-photo-heading-icon, .salon-photo-upload-heading > span { display: grid; place-items: center; flex-shrink: 0; width: 36px; height: 36px; color: #de5266; background: #fff0f2; border-radius: 11px; svg { width: 21px; height: 21px; } }\n  .salon-photo-gallery { padding: 0 16px 16px; }\n  .salon-photo-sources { display: flex; gap: 5px; overflow-x: auto; padding: 2px 1px 12px; scrollbar-width: none; &::-webkit-scrollbar { display: none; } button { display: inline-flex; align-items: center; justify-content: center; gap: 5px; flex-shrink: 0; min-height: 38px; padding: 7px 9px; border-radius: 10px; border: 1px solid #e6eaf1; background: #fff; color: #68758b; font-size: 11px; font-weight: 500; cursor: pointer; span { min-width: 16px; padding: 1px 3px; border-radius: 5px; background: #f2f4f8; color: #8791a2; font-variant-numeric: tabular-nums; } &[aria-pressed=true] { background: #fff1f3; border-color: #f1bec7; color: #c73752; span { background: #ffe1e7; color: #c73752; } } } }\n  .salon-photo-grid { padding: 0; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px 9px; figure { margin: 0; min-width: 0; } figcaption { padding: 6px 1px 0; strong { display: block; font-size: 11px; font-weight: 550; color: #45536a; } > span { display: block; color: #8a95a6; font-size: 10px; line-height: 1.4; margin-top: 3px; } } }\n  .salon-photo-thumb { display: block; position: relative; padding: 0; width: 100%; aspect-ratio: 1.12; min-height: 88px; border: 0; border-radius: 11px; overflow: hidden; background: #eef1f5; cursor: pointer; img { display: block; width: 100%; height: 100%; object-fit: cover; border-radius: 0; transition: transform .18s; } > span:not(.salon-photo-unavailable) { position: absolute; bottom: 6px; left: 6px; max-width: calc(100% - 12px); padding: 3px 5px; border-radius: 5px; color: #fff; background: #243044b8; font-size: 9px; line-height: 1.2; } &:hover img { transform: scale(1.025); } }\n  .salon-photo-empty { display: grid; justify-items: center; text-align: center; padding: 24px 14px 18px; border: 1px solid #edf0f5; background: #fafbfc; border-radius: 13px; > svg { width: 32px; height: 32px; color: #b7c0ce; margin-bottom: 11px; } strong { color: #68758b; font-size: 13px; font-weight: 550; } p { margin: 7px 0 0; color: #9099aa; font-size: 12px; line-height: 1.5; max-width: 260px; } }\n  .salon-photo-hint { font-size: 11px; line-height: 1.6; margin: 12px 0 0; color: #8792a5; }\n  .salon-photo-more { display: block; margin: 12px auto 0; padding: 8px 14px; min-height: 42px; color: #68758b; font-size: 12px; background: #f5f7fa; border: 0; border-radius: 9px; cursor: pointer; }\n  .salon-photo-upload { position: relative; padding: 18px 16px 16px; border-top: 1px solid #edf0f5; display: grid; gap: 14px; .salon-photo-hint { margin: 0; } }\n  .salon-photo-upload-heading { display: flex; align-items: center; gap: 10px; h3 { margin: 0; font-size: 14px; line-height: 1.4; } p { margin: 3px 0 0; font-size: 11px; color: #8792a5; } > span { width: 31px; height: 31px; border-radius: 9px; } }\n  .salon-photo-pick { display: grid; justify-items: center; text-align: center; padding: 19px 12px; border: 1px dashed #ebbdc6; border-radius: 14px; background: linear-gradient(140deg, #fff7f8, #fcfdff); > strong { font-size: 13px; color: #566178; font-weight: 550; } > p { color: #8a93a3; font-size: 12px; line-height: 1.55; margin: 7px 0 13px; } > small { color: #99a1af; font-size: 10px; margin-top: 10px; line-height: 1.5; } }\n  .salon-photo-pick-icon { display: grid; place-items: center; width: 44px; height: 44px; border-radius: 13px; margin-bottom: 12px; background: #fff; color: #e88495; box-shadow: 0 3px 10px #d4547010; svg { width: 25px; height: 25px; } }\n  .salon-photo-select { display: inline-flex; gap: 7px; align-items: center; justify-content: center; min-height: 44px; padding: 9px 17px; border: 1px solid #edc8d0; border-radius: 10px; background: #fff; color: #cd4d66; font-size: 13px; font-weight: 550; cursor: pointer; svg { width: 18px; height: 18px; } }\n  .salon-photo-file-input { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); padding: 0; border: 0; opacity: 0; }\n  .salon-photo-options { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; label { display: grid; gap: 6px; font-size: 11px; color: #7a8599; min-width: 0; } select { width: 100%; min-width: 0; box-sizing: border-box; min-height: 44px; padding: 9px; font-size: 16px; background: #fff; border: 1px solid #dfe5ee; border-radius: 10px; color: #47546c; } }\n  .salon-photo-selected { display: grid; gap: 8px; > div { display: flex; align-items: center; gap: 10px; padding: 8px; border: 1px solid #e8ecf3; border-radius: 10px; min-width: 0; } img { width: 48px; height: 48px; border-radius: 8px; object-fit: cover; flex-shrink: 0; } span { display: grid; min-width: 0; gap: 4px; flex: 1; strong { font-size: 11px; color: #59657b; font-weight: 500; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; } small { color: #9aa3b2; font-size: 10px; } } button { display: grid; place-items: center; border: 0; background: #f5f7fa; color: #939cac; width: 36px; min-height: 44px; border-radius: 8px; svg { width: 16px; height: 16px; } } }\n  .salon-photo-submit { width: 100%; display: inline-flex; align-items: center; justify-content: center; min-height: 46px; border: 0; border-radius: 11px; background: #e9748c; color: #fff; font-size: 13px; font-weight: 600; cursor: pointer; &:disabled { opacity: 1; background: #f7d8df; color: #fff; cursor: default; } }\n  .salon-photo-progress { display: grid; gap: 7px; font-size: 12px; color: #78849a; progress { width: 100%; height: 5px; accent-color: #df718a; } }\n  .salon-photo-error, .salon-photo-success { margin: 0; padding: 10px 12px; border-radius: 9px; line-height: 1.5; font-size: 12px; overflow-wrap: anywhere; }\n  .salon-photo-error { color: #b34b54; background: #fff2f2; }\n  .salon-photo-success { color: #388467; background: #f0faf5; }\n  @media(max-width: 390px) { .salon-photo-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } .company-info-card-heading { gap: 5px; } .salon-photo-heading { gap: 7px; } .salon-photo-heading-icon { width: 30px; height: 30px; } .salon-photo-sources button { padding: 7px 8px; font-size: 10px; } }\n  @media(prefers-reduced-motion: reduce) { .salon-photo-thumb img { transition: none; } }\n}\n.salon-photo-unavailable { width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 6px; color: #9aa6b6; font-size: 10px; padding: 8px; box-sizing: border-box; svg { width: 24px; height: 24px; } }\n.salon-photo-viewer { position: fixed; inset: 0; z-index: 10020; padding: max(16px, env(safe-area-inset-top)) 14px max(16px, env(safe-area-inset-bottom)); box-sizing: border-box; display: grid; place-items: center; background: #182338df; overscroll-behavior: contain; > div { width: min(880px, 100%); min-width: 0; border-radius: 16px; overflow: hidden; background: #fff; outline: none; box-shadow: 0 20px 80px #0004; } header { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 12px 15px; color: #3e4b64; > div { min-width: 0; display: grid; gap: 5px; } strong { font-size: 14px; } span { font-size: 12px; color: #8c97a7; } } button { border: 0; background: #f2f5f9; color: #5d6b83; border-radius: 9px; width: 44px; height: 44px; display: grid; place-items: center; flex-shrink: 0; cursor: pointer; &:disabled { opacity: .35; } svg { width: 20px; height: 20px; } &:focus-visible { outline: 3px solid #dc6c85; } } footer { display: flex; align-items: center; justify-content: center; gap: 20px; padding: 10px; color: #7b879a; font-size: 12px; } .salon-photo-next { display: flex; transform: rotate(180deg); } }\n.salon-photo-viewer-image { background: #f3f5f8; width: 100%; height: min(68vh, 680px); height: min(68dvh, 680px); display: grid; place-items: center; img { width: 100%; height: 100%; object-fit: contain; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
